import { Env } from '@nio-pow/mfe-vue3'
import { uniqArrayByKey } from '@/utils/uniqArray'
import internal from './apps.internal'
import international from './apps.international'

let apps: any[] = []

function getOriginMicroApps() {
  try {
    const appType = Env.getAppType()
    const originApps = { internal, international }
    apps = originApps[appType]
  } catch (error) {
    console.error('[MFE error getOriginMicroApps]', error)
  }

  if (process.env.NODE_ENV === 'development') {
    // 支持本地配置 apps.local.ts 文件进行调试
    try {
      let localApps = require('./apps.local')
      localApps = localApps.default || localApps
      apps = uniqArrayByKey([...localApps, ...apps], 'activeRule')
    } catch (error) {}
  }
  return apps
}
getOriginMicroApps()

export default apps
